export default function SparklingFolderIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3L4.30909 3C3.5861 3 3 3.5861 3 4.30909L3 19.6909C3 20.4139 3.5861 21 4.30909 21L19.6909 21C20.4139 21 21 20.4139 21 19.6909L21 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7C12 7 12.212 9.63887 13.2866 10.7135C14.3611 11.788 17 12 17 12C17 12 14.3611 12.212 13.2866 13.2866C12.212 14.3611 12 17 12 17C12 17 11.788 14.3611 10.7135 13.2866C9.63887 12.212 7 12 7 12C7 12 9.63887 11.788 10.7135 10.7135C11.788 9.63887 12 7 12 7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 2.5C18.75 2.5 18.8666 3.95138 19.4576 4.5424C20.0486 5.13342 21.5 5.25 21.5 5.25C21.5 5.25 20.0486 5.36658 19.4576 5.9576C18.8666 6.54862 18.75 8 18.75 8C18.75 8 18.6334 6.54862 18.0424 5.9576C17.4514 5.36658 16 5.25 16 5.25C16 5.25 17.4514 5.13342 18.0424 4.5424C18.6334 3.95138 18.75 2.5 18.75 2.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
